/* eslint-disable react/button-has-type, react/jsx-props-no-spreading  */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from './Button';

import Backgrounds from '../icons/button';

import styles from '../../../styles/buttons/full.scss';

const propTypes = {
    backgrounds: PropTypes.arrayOf(PropTypes.func),
    highlighted: PropTypes.bool,
    centered: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    backgrounds: [Backgrounds.medium],
    highlighted: false,
    centered: false,
    className: null,
};

const FullButton = ({ backgrounds, centered, highlighted, className, ...props }) => {
    // console.log(props);
    return (
        <Button
            {...props}
            backgrounds={backgrounds}
            centered={centered}
            highlighted={highlighted}
            external
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        />
    );
};

FullButton.propTypes = propTypes;
FullButton.defaultProps = defaultProps;

export default FullButton;
